<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Tipo de Projeto">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                -->
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Tipo de Projeto</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>

            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <!--
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
          -->
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                     
                    </b-card>
                </template>
                
             
                <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
             
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Tipo de Projeto"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
          <b-row>
            <b-col md="12"> 
              <b-form>
                <b-form-group
                description=""
                label="Tipo de Projeto Principal"
                label-for="parentId"
                :label-cols="3"
                :horizontal="true">
                  <b-form-select id="parentId"
                    v-model="selectedItem.parentId"
                    :plain="true"
                    :options="this.typeDDL"
                    >
                  </b-form-select>
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>

          <b-row>
            <b-col md="12"> 
              <b-form>
                <b-form-group
                description=""
                label="Setor"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Descrição"
                label-for="description"
                :label-cols="3"
                :horizontal="true">
                <textarea v-model="selectedItem.description" class="form-control" id="description" name="description" rows="3" placeholder=""></textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
     
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Tipo de Projeto</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
        typeDDL: [],
        companyDDL: [],
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          key: '',
          companyId: null
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "100px" } },
         // {key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          //{key: 'projectTypeName', label: 'Tipo de Projeto', sortable: true },
         // {key: 'code', label: 'Código', sortable: true, thStyle: { width: "80px" }  },
          {key: 'name', label: 'Tipo de Projeto', sortable: true },
          {key: 'parentName', label: 'Principal', sortable: true },
          {key: 'description', label: 'Descrição', sortable: true },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'productTotal', label: 'Produtos', sortable: false, thStyle: { width: "40px" } },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
    
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      async saveItem(currentItem) {
        
        var s = this;
        var postData = {...currentItem};

        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid

        console.log(postData)

        await axios.post(
            this.$store.state.ws_url + "/project/type",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);

            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
      },

      save() {

        let msgError = [];

        if(!this.selectedItem.companyId || this.selectedItem.companyId <= 0)
            msgError.push("Empresa");
        if(!this.selectedItem.name || this.selectedItem.name.length <= 0)
            msgError.push("Tipo de Projeto")


        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
      },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = newItem;      
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        
        this.selected = items
        
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
          if(!this.tableSelectable) {
            console.log(item);
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },

      async getType() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
         
          await axios.get(
              this.$store.state.ws_url + "/project/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
              s.typeDDL = resp.data.obj;

              if(!s.filters.typeId || s.filters.typeId <= 0) {
                if(s.typeDDL && s.typeDDL.length > 0) {
                s.filters.typeId = s.typeDDL[0].value
              }

            }
            
            s.refreshData();  
            

          }).catch(function(error) {
            console.log(error)
          })
          
      },


      async refreshData() {
        
          this.isBusy = true
            var s = this;
            var currentUser = this.$store.state.currentUser;
        
            await axios.get(
                this.$store.state.ws_url + "/project/type?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
              s.items = resp.data.obj;
            }).catch(function(error) {
              console.log(error)
              toast ({
                  type: VueNotifications.types.warn,
                  title: 'Erro',
                  message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                  timeout: 5000
              })
            })
            
            this.isBusy = false;
        
      },

      changeCompany() {
        this.getType()
        this.refreshData()
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.changeCompany()
      
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>